import { DeductionService } from "./../../../services/catalogs/DeductionService";
import { CreateDeductionDto } from "./../../../dtos/catalogs/deduction/CreateDeductionDto";
import React from "react";
import { DeductionDetail } from "../../../components/Pages/Catalogs/Deduction/DeductionDetail";
import { CatalogService } from "../../../services/catalogs/CatalogService";
import { IAppEntity } from "../../entities";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { NFLookupDeduction } from "../../../components/Shared/NewForms/NFLookupDeduction";
import DeductionList from "../../../components/Pages/Catalogs/Deduction/DeductionList";

export const Deduction: IAppEntity = {
  entityType: "catalog",
  title: "Deduction",
  pluralTitle: "Deduction",
  apiUrl: "Deductions",
  apiEnum: ReferenceTypes.CatalogDeduction,
  getDetailViewComponent(
    model: any,
    modelUpdatedEvent: (model: any) => void
  ): any {
    return React.createElement(DeductionDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    });
  },
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(DeductionList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupDeduction, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService() {
    return new DeductionService(this.apiUrl);
  },
  getEmptyModel(): CreateDeductionDto {
    return {
      name: "",
      description: "",
      deductionType: 0,
      createdDate: new Date(),
    };
  },
};
